module.exports = __webpack_public_path__ + "static/img/bottom.9fe7de56.png";